import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { taxActions, taxFeature } from '../+state';
import { Tax } from '../entities/tax.entity';

@Injectable({ providedIn: 'root' })
export class TaxFacade {
  readonly #store = inject(Store);

  public tax$: Observable<Tax[]> = this.#store.select(taxFeature.selectTax);
  public isReady$: Observable<boolean> = this.#store.select(taxFeature.selectIsReady);
  public loading$: Observable<boolean> = this.#store.select(taxFeature.selectLoading);

  public loadTax() {
    this.#store.dispatch(taxActions.loadTaxData());
  }
}
